"use strict";
/**
 * SearchParams - shared between server and client.
 * Describes the query parameters for the search/browse API.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORT_DEFAULT_DIRECTION = exports.SORT_OPTIONS = void 0;
exports.SORT_OPTIONS = [
    'recent', 'distance', 'activity', 'age', 'newest',
    'height', 'weight', 'income', 'name', 'liked_at', 'answered',
];
// Default sort directions per sort type — what makes sense from a UX perspective
exports.SORT_DEFAULT_DIRECTION = {
    recent: 'desc', // Most recently updated first
    activity: 'desc', // Most recently active first
    newest: 'desc', // Newest users first
    distance: 'asc', // Closest first
    age: 'asc', // Youngest first
    height: 'asc', // Shortest first
    weight: 'asc', // Lightest first
    income: 'asc', // Lowest first
    name: 'asc', // A-Z first
    liked_at: 'desc', // Most recent likes first
    answered: 'desc', // Most answered first
};
